module.exports = __webpack_public_path__ + "img/bess_item.27bfefb9.svg";